/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { normalizeRepoUrl } from './repoPaths';
import type { Product } from '@shared/types/products';

export interface RepoContext {
  repoUrl?: string;
  repoPath?: string;
  normalizedRepoUrl: string | null;
}

export function getRepoContext(activeProduct: Product | null, activeRepoUrl: string | null | undefined): RepoContext {
  const repoUrl = activeProduct?.repositoryUrl ?? activeRepoUrl ?? undefined;

  if (!repoUrl) {
    return {
      repoUrl: undefined,
      repoPath: undefined,
      normalizedRepoUrl: null,
    };
  }

  const normalized = normalizeRepoUrl(repoUrl);
  const repoPath = activeProduct?.repoPath ?? undefined;

  return {
    repoUrl: normalized,
    repoPath,
    normalizedRepoUrl: normalized,
  };
}

export function resolveApiUrl(path: string, repoContext: RepoContext): string {
  const base = import.meta.env.DEV ? `http://localhost:3002${path}` : path;
  const params = new URLSearchParams();

  if (repoContext.repoUrl) {
    params.set('repoUrl', repoContext.repoUrl);
  }

  if (repoContext.repoPath) {
    params.set('repoPath', repoContext.repoPath);
  }

  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
